import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Button,
  CssBaseline,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  IconButton,
  TextField,
  Menu,
  MenuItem,Tooltip,
} from '@mui/material';
import { Close, LocationOn as LocationOnIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { Warehouse_API_ENDPOINTS } from '../../../config/api/apiCallWarehouse';
import CallAlertBar from '../../../Layout/Alertbar';
import WHAddUpdateLocationType from './WHAddUpdateLocationType';
import { useNavigate } from 'react-router-dom';
import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import ModuleHelpDialog from '../../../components/ModuleHelpDialog';
import { moduleHelpData } from '../../../data/moduleHelpData';
import HelpIcon from '@mui/icons-material/HelpOutline';

const WHLocationTypeIndex = ({ handleBackWinderMachineEntry }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [locationList, setLocationList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [filters, setFilters] = useState({
    code: '',
    description: '',
    status: '',
  });

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [locationFormData, setLocationFormData] = useState({});

  // Alerts
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('info');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');

  // 🔽 Menu state (All / Active / Inactive)
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState('All Location Types');
  const open = Boolean(anchorEl);


  const [helpOpen, setHelpOpen] = useState(false);
      const handleCloseHelp = () => setHelpOpen(false);
      const handleHelpMenuClick = () => setHelpOpen(true);

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
const userPermissions = useUserPermissions();
  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    handleMenuClose();

    // Reset filters
    setFilters({ code: '', description: '', status: '' });

    // Apply filter
    if (option === 'All Location Types') setFilteredList(locationList);
    else if (option === 'Active Location Types')
      setFilteredList(locationList.filter((x) => x.status === 'Active' || x.status === true));
    else if (option === 'Inactive Location Types')
      setFilteredList(locationList.filter((x) => x.status === 'Inactive' || x.status === false));
  };

  // ✅ Load Data
  const LoadLocationList = () => {
    const payload = {
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
    };

    callApi(
      Warehouse_API_ENDPOINTS.locationType.list,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setLocationList(data);
          setFilteredList(data);
        } else {
          setLocationList([]);
          setFilteredList([]);
          setAlertSeverity('warning');
          setAlertTitle('Warning');
          setAlertMessage('No location type data found!');
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setLocationList([]);
        setFilteredList([]);
        setAlertSeverity('error');
        setAlertTitle('Error');
        setAlertMessage('Unable to load location type details');
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    LoadLocationList();
  }, []);

  // ✅ Column Filters Logic
  // useEffect(() => {
  //   let baseList = locationList;

  //   if (selectedOption === 'Active Location Types') {
  //     baseList = locationList.filter((x) => x.status === 'Active' || x.status === true);
  //   } else if (selectedOption === 'Inactive Location Types') {
  //     baseList = locationList.filter((x) => x.status === 'Inactive' || x.status === false);
  //   }

  //   const filtered = baseList.filter((row) => {
  //     const statusText = row.status?.toString().toLowerCase() || '';
  //     return (
  //       row.code?.toLowerCase().includes(filters.code.toLowerCase()) &&
  //       row.description?.toLowerCase().includes(filters.description.toLowerCase()) &&
  //       statusText.includes(filters.status.toLowerCase())
  //     );
  //   });

  //   setFilteredList(filtered);
  // }, [filters, locationList, selectedOption]);
useEffect(() => {
  let baseList = locationList;

  // Step 1: Apply menu filter
  if (selectedOption === 'Active Location Types') {
    baseList = locationList.filter(
      (x) => x.status === true || (typeof x.status === 'string' && x.status.toLowerCase() === 'active')
    );
  } else if (selectedOption === 'Inactive Location Types') {
    baseList = locationList.filter(
      (x) => x.status === false || (typeof x.status === 'string' && x.status.toLowerCase() === 'inactive')
    );
  }

  // Step 2: Apply column-wise filters
  const filtered = baseList.filter((row) => {
    // ✅ Normalize all possible status types
    const statusText =
      row.status === true ||
      (typeof row.status === 'string' && row.status.toLowerCase() === 'active')
        ? 'active'
        : 'inactive';

    // ✅ Normalize all filter inputs
    const fCode = (filters.code || '').toLowerCase();
    const fDesc = (filters.description || '').toLowerCase();
    const fStatus = (filters.status || '').toLowerCase();

    // ✅ Apply case-insensitive filtering
    return (
      (row.code || '').toLowerCase().includes(fCode) &&
      (row.description || '').toLowerCase().includes(fDesc) &&
      statusText.startsWith(fStatus)
    );
  });

  setFilteredList(filtered);
}, [filters, locationList, selectedOption]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAddLocation = () => {
    setLocationFormData({});
    setIsFormOpen(true);
  };

  const handleEditLocation = (loc) => {
    const payload = {
      p_company_id: localStorage.getItem('companyid'),
      p_plant_id: 1,
      p_id: loc.location_type_id,
    };

    callApi(
      Warehouse_API_ENDPOINTS.locationType.getById,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    )
      .then((data) => {
        if (data && data.length > 0) {
          setLocationFormData(data[0]);
          setIsFormOpen(true);
        } else {
          setAlertSeverity('warning');
          setAlertTitle('Warning');
          setAlertMessage('No data found for selected Location Type');
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertSeverity('error');
        setAlertTitle('Error');
        setAlertMessage('Failed to fetch Location Type details');
        setAlertOpen(true);
      });
  };

  const handleExit = () => {
    handleBackWinderMachineEntry();
  };

  return (
    <Grid>
      {!isFormOpen && (
        <>
          <CssBaseline />
          <AppBar position="static" sx={{ backgroundColor: 'inherit', borderRadius: '0px', height: '48px', justifyContent: 'center' }}>
            <Toolbar>
               {/* 🔽 Menu for Active/Inactive/All */}
          <Box >
            <Button
              color="secondary"
              onClick={handleMenuClick}
              endIcon={<ExpandMoreIcon sx={{ color: 'teal', fontSize: '18px' }} />}
              sx={{ textTransform: 'none', fontSize: '16px', fontWeight: 500 }}
            >
              {selectedOption}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
              <MenuItem onClick={() => handleMenuItemClick('All Location Types')}>All Location Types</MenuItem>
              <MenuItem onClick={() => handleMenuItemClick('Active Location Types')}>Active Location Types</MenuItem>
              <MenuItem onClick={() => handleMenuItemClick('Inactive Location Types')}>Inactive Location Types</MenuItem>
            </Menu>
          </Box>
          {hasPermission(userPermissions, "Location type", "Create") && (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                startIcon={<LocationOnIcon />}
                sx={{ ml: 'auto', textTransform: 'none' }}
                onClick={handleAddLocation}
              >
                New Location Type
              </Button>
          )}

           <Tooltip title="View help document details" arrow>
                          <IconButton
                            size="small"
                            aria-label="help"
                            sx={{ mx: 1 }}
                            onClick={handleHelpMenuClick}
                          >
                            <HelpIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                        
                        
                                                <ModuleHelpDialog
                                                    open={helpOpen}
                                                    onClose={handleCloseHelp}
                                                    data={moduleHelpData.LocationTypeMaster}
                                                />

              <IconButton onClick={handleExit}>
                <Close style={{ fontSize: '16px', color: '#2196F3' }} />
              </IconButton>
            </Toolbar>
          </AppBar>

         

          <CallAlertBar
            parentRollMsgOpen={alertOpen}
            setParentRollMsgOpen={setAlertOpen}
            parentRollSeverityvalue={alertSeverity}
            setParentRollSeverityvalue={setAlertSeverity}
            parentRollAlertTitleValue={alertTitle}
            setParentRollAlertTitleValue={setAlertTitle}
            parentRollMessageValue={alertMessage}
            setParentRollMessageValue={setAlertMessage}
          />

          {/* 🔽 Table Section */}
          <Grid container padding={1} spacing={1}>
            <Grid item xs={12}>
              <Box
                sx={{
                  '& .MuiTableCell-root': {
                    border: '1px solid',
                    borderColor: `${colors.primary[400]} !important`,
                    padding: '4px',
                  },
                  maxHeight: '75vh',
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': { width: '8px' },
                  '&::-webkit-scrollbar-thumb': {
                    background: colors.blueAccent[600],
                    borderRadius: '10px',
                  },
                }}
              >
                <TableContainer>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>LOCATION TYPE CODE</TableCell>
                        <TableCell>LOCATION TYPE DESCRIPTION</TableCell>
                        <TableCell>STATUS</TableCell>
                      </TableRow>

                      {/* 🔍 Column Filter Row */}
                      <TableRow>
                        {Object.keys(filters).map((key) => (
                          <TableCell key={key}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Search..."
                              fullWidth
                              value={filters[key]}
                              onChange={(e) => handleFilterChange(key, e.target.value)}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {filteredList.map((loc) => (
                        <TableRow key={loc.location_type_id}>
                          <TableCell
                            sx={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleEditLocation(loc)}
                          >
                            {loc.code}
                          </TableCell>
                          <TableCell>{loc.description}</TableCell>
                          <TableCell>
                            <Typography sx={{ fontWeight: 600 }}>
                             {loc.status === true ? "Active" : "Inactive"}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      {isFormOpen && (
        <WHAddUpdateLocationType
          locationFormData={locationFormData}
          setLocationFormData={setLocationFormData}
          setIsFormOpen={setIsFormOpen}
          LoadLocationList={LoadLocationList}
        />
      )}
    </Grid>
  );
};

export default WHLocationTypeIndex;
